import { render, staticRenderFns } from "./ResumePrivateImageCard.vue?vue&type=template&id=16bfe8da&"
import script from "./ResumePrivateImageCard.vue?vue&type=script&lang=js&"
export * from "./ResumePrivateImageCard.vue?vue&type=script&lang=js&"
import style0 from "./ResumePrivateImageCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports